import React, { FC, useCallback } from 'react'
import cn from 'classnames'
import { ListChildComponentProps } from 'react-window'
import ProductPhoto from '../../components/ProductPhoto'
import Button from '../../components/Button'
import { money } from '../../common/display'

const LocationInventoryProductRow: FC<ListChildComponentProps> = ({
  data,
  index,
  style,
}) => {
  const product = data.products[index]
  const isEditable = !!data.onAdd
  const multiCatalogEnabled = data.multiCatalogEnabled
  const existingItem = (data.allItems ?? data.items)?.find(
    (item: any) => item.product.id === product.id,
  )

  const handleAdd = useCallback(() => {
    data.onAdd(product)
  }, [data.onAdd, product])
  const price = [
    product.price != null ? money(product.price) : null,
    product.unit || 'EACH',
  ]
    .filter(Boolean)
    .join(' / ')

  if (existingItem) {
    const pricePerUnit = `${money(existingItem.price || product.price || 0)} / ${existingItem.unit || 'EACH'}`
    const total = `$${((existingItem.inventory || 0) * (existingItem.price || product.price || 0)).toFixed(2)}`

    return (
      <div className="order-modal_list-item" style={style}>
        <div className="order-modal_list-product order-snippet -small">
          <div className="order-snippet_col -info -large">
            <div className="order-snippet_image-wrapper">
              <ProductPhoto
                photo={product.photo}
                className="order-snippet_image"
              />
            </div>
            <div className="order-snippet_title">{product.name}</div>
            <div className="order-snippet_info">
              <div className="order-snippet_sku">{product.code}</div>
              {multiCatalogEnabled && product.erpCatalogName && (
                <div className="order-snippet_erp-catalog">
                  {product.erpCatalogName}
                </div>
              )}
            </div>
            <div className="order-snippet_price">{pricePerUnit}</div>
          </div>
        </div>
        <div className="tile -bordered -done">
          <button className="tile_count-toggle clear-button">
            {existingItem.inventory ?? 0}
          </button>
        </div>
        <div className="tile -done -bordered">{total}</div>
      </div>
    )
  }

  return (
    <div
      className={cn('order-modal_list-item', {
        '-product': isEditable,
        '-full-width': !isEditable,
      })}
      style={style}
    >
      <div className="order-modal_list-product order-snippet -small">
        <div className="order-snippet_col -info -large">
          <div className="order-snippet_image-wrapper">
            <ProductPhoto
              photo={product.photo}
              className="order-snippet_image"
            />
          </div>
          <div className="order-snippet_title">{product.name}</div>
          <div className="order-snippet_info">
            <div className="order-snippet_sku">{product.code}</div>
            {multiCatalogEnabled && (
              <div className="order-snippet_erp-catalog">
                {product.erpCatalogName}
              </div>
            )}
          </div>
          <div className="order-snippet_price">{price}</div>
        </div>
      </div>
      {isEditable && (
        <Button
          className="tile clear-button -bordered order-modal_list-action"
          onClick={handleAdd}
          color="link"
          disabled={data.loading}
        >
          Add To Location
        </Button>
      )}
    </div>
  )
}

export default LocationInventoryProductRow
